export const formatToDecimals = <T>(angleValue: T | number): T | number => {
    const angleValueNumber = Number(angleValue);
    if (Number.isFinite(angleValueNumber)) {
        return Number(angleValueNumber.toFixed(1));
    }

    return angleValue;
};
